import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_post_link = _resolveComponent("post-link")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_post_group_btn = _resolveComponent("post-group-btn")!
  const _component_post_faces_btn = _resolveComponent("post-faces-btn")!
  const _component_post_notes_btn = _resolveComponent("post-notes-btn")!
  const _component_trash_btn = _resolveComponent("trash-btn")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!

  return (_openBlock(), _createBlock(_component_q_toolbar, null, {
    default: _withCtx(() => [
      _createVNode(_component_q_toolbar_title, { class: "text-subtitle1 text-grey-7" }, {
        default: _withCtx(() => [
          _createVNode(_component_post_link, {
            url: _ctx.post.link,
            "social-site": _ctx.post.socialSite
          }, null, 8, ["url", "social-site"])
        ]),
        _: 1
      }),
      (_ctx.group && _ctx.post.parent)
        ? (_openBlock(), _createBlock(_component_post_group_btn, {
            key: 0,
            "post-group": _ctx.post.parent,
            class: "q-ml-sm",
            round: "",
            flat: ""
          }, null, 8, ["post-group"]))
        : _createCommentVNode("", true),
      _createVNode(_component_post_faces_btn, {
        post: _ctx.post,
        class: "q-ml-sm",
        round: "",
        flat: ""
      }, null, 8, ["post"]),
      (_ctx.notes)
        ? (_openBlock(), _createBlock(_component_post_notes_btn, {
            key: 1,
            post: _ctx.post,
            class: "q-ml-sm",
            title: _ctx.notesBtnTitle,
            round: "",
            flat: ""
          }, null, 8, ["post", "title"]))
        : _createCommentVNode("", true),
      (!_ctx.post.isTrashed && _ctx.trash)
        ? (_openBlock(), _createBlock(_component_trash_btn, {
            key: 2,
            post: _ctx.post,
            round: "",
            flat: "",
            class: "q-ml-sm",
            onTrashed: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('trashed', $event[0])))
          }, null, 8, ["post"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}